<template>
  <div class="header">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="header-title">Surveys</h1>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-primary" @click="verifyExport()">
            <span class="fe fe-download" v-if="!pendingExport"></span>
            <span class="fas fa-spinner fa-spin" v-else></span>
            Export
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, createNamespacedHelpers } from 'vuex'
const SurveyModule = createNamespacedHelpers('survey')
const userModule = createNamespacedHelpers('user')

// @group Survey
// This Component is the Header on the 'Feedback' page
export default {
  name: 'SurveyHeader',
  data: () => ({
    pendingExport: false
  }),
  computed: {
    ...userModule.mapState(['onlineUser'])
  },
  methods: {
    ...SurveyModule.mapActions(['generateSurveysCSV']),

    // @vuese
    // Displays modal verifying the user wants to export with the current filters.
    async verifyExport() {
      const message = `
        A CSV file will be created with the filters 
        that are currently applied to the Surveys table.
        `
      const h = this.$createElement
      const titleVNode = h('div', [
        h('h2', { class: ['mb-0'], domProps: { innerHTML: 'Confirm Export' } })
      ])
      const exportConfirmed = await this.$bvModal.msgBoxConfirm(message, {
        title: [titleVNode],
        size: 'md',
        okTitle: 'Export',
        cancelTitle: 'Cancel',
        centered: true
      })
      if (exportConfirmed) this.exportSurveysCSV()
    },

    // @vuese
    // Shows confirmation modal and initiates async export
    async exportSurveysCSV() {
      try {
        const h = this.$createElement
        const titleVNode = h('div', [
          h('h2', { class: ['mb-0'], domProps: { innerHTML: 'Your export has been initiated' } })
        ])

        const email = this.onlineUser.email || ''

        const messageVNode = h('p', {
          domProps: {
            innerHTML: `This could take a couple of minutes.
        If you need to leave our site, we'll email the export to <strong>${email}</strong>`
          }
        })

        const okayMessageBox = await this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          size: 'md',
          okTitle: 'Okay',
          centered: true
        })

        if (okayMessageBox) {
          this.pendingExport = true
          await this.generateSurveysCSV()
        }
      } catch (error) {
        this.pendingExport = false
        this.$notify({
          type: 'error',
          duration: 5000,
          title:
            error?.status === 403
              ? 'Some selected locations are no longer available. Refresh your filters and try again.'
              : `Exporting surveys failed! Try again`
        })
      } finally {
        this.pendingExport = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
